import React, { useRef } from 'react';
import ReactToPrint from "react-to-print";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PrintIcon from "@material-ui/icons/Print";
import FylgibrefToPrint from './FylgibrefToPrint';


const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing()
  }
}));

export default function FylgibrefPrint(props) {
  const classes = useStyles();
  const { formState, kjosandi, activeKosning } = props; 
  const fylgibrefToPrintRef = useRef();
 
  return (
    <React.Fragment>
      <ReactToPrint
        trigger={() => (
          <Button color="primary" variant="contained" size="large">
            <PrintIcon className={classes.icon} />
            Prenta fylgibréf
          </Button>
        )}
        content={() => fylgibrefToPrintRef.current}
      />

      <div style={{ display: "none" }}>
        <FylgibrefToPrint
          formState={formState}
          kjosandi={kjosandi}
          activeKosning={activeKosning}
          ref={fylgibrefToPrintRef}
        />
      </div>
    </React.Fragment>
  );
}